import { render, staticRenderFns } from "./ReasonProofreadTipsDialog.vue?vue&type=template&id=2d91c57b&scoped=true"
import script from "./ReasonProofreadTipsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReasonProofreadTipsDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReasonProofreadTipsDialog.vue?vue&type=style&index=0&id=2d91c57b&prod&lang=scss"
import style1 from "./ReasonProofreadTipsDialog.vue?vue&type=style&index=1&id=2d91c57b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91c57b",
  null
  
)

export default component.exports